import { Directive, HostBinding } from '@angular/core';

@Directive({
	standalone: true,
	selector: 'button[cm-mini-button], a[cm-mini-button]',
})
export class CmMiniButtonDirective {
	@HostBinding('class.cm-mini-button')
	elementClass = true;

	constructor() {}
}
